// src/App.jsx
// Root component — assembles all sections
import { WalletProvider } from "./context/WalletContext";
import Navbar              from "./components/Navbar";
import HeroSection         from "./components/HeroSection";
import StatusStrip         from "./components/StatusStrip";
import EcosystemSection    from "./components/EcosystemSection";
import FeaturesSection     from "./components/FeaturesSection";
import TokenUtilitySection from "./components/TokenUtilitySection";
import RoadmapSection      from "./components/RoadmapSection";
import FAQSection          from "./components/FAQSection";
import Footer              from "./components/Footer";
import WalletModal         from "./components/WalletModal";

export default function App() {
  return (
    <WalletProvider>
      {/* Background */}
      <div className="bg-grid" />
      <div className="bg-glow-1" />
      <div className="bg-glow-2" />

      <Navbar />
      <HeroSection />
      <StatusStrip />
      <EcosystemSection />
      <FeaturesSection />
      <TokenUtilitySection />
      <RoadmapSection />
      <FAQSection />
      <Footer />

      {/* Modals */}
      <WalletModal />
    </WalletProvider>
  );
}
